import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';
import { useEffect } from 'react';

export const useViewModel = () => {
    const stripeSettings = useFeature('stripe');
    const inAppPurchases = useFeature('inAppPurchases')?.enabled || false;

    useEffect(() => {
        if (
            inAppPurchases &&
            stripeSettings?.enabled &&
            stripeSettings?.customerPortalUrl &&
            typeof window !== 'undefined'
        ) {
            window.location.href = stripeSettings?.customerPortalUrl;
        }
    }, [stripeSettings, inAppPurchases]);
};
